/*
 * @Author:
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-12 13:12:21
 * @Description:
 */
import type {
    ProfileCurrenciesResponseState,
    UserProfileCurrenciesResponseState,
    UserInfo,
} from '@/socket/profile/dto/index';

// type Lang = 'en' | 'cn'; 
interface LangParams {
    lang: string;
}
interface LangSettingRespond {
    success: boolean;
}

export const useProfileSocket = () => {
    const rootPath = 'profile';
    // 👇查询用户信息（当前币种，余额等）
    const EMIT_PROFILE_TOKEN = (
        data: {
            token: string;
            currency?: string; // 当前币种
            fingerprint: string;
        },
    ) => {
        return asyncEmit<UserInfo>(
            `${rootPath}.token`,
            data,
        );
    };

    // 👇查询初始汇率
    const EMIT_PROFILE_GETCURRENCIES = (
        callback: (data: ProfileCurrenciesResponseState) => any,
    ) => {
        socket.emit(`${rootPath}.getCurrencies`, {}, callback);
    };

    // 👇查询用户统计
    const EMIT_PROFILE_USER_STATISTIC = (
        dto: { userId },
        callback: (data: UserProfileCurrenciesResponseState) => any,
    ) => {
        socket.emit(`${rootPath}.userStatistic`, dto, callback);
    };

    // 👇 提交用户选择的语言
    const EMIT_USER_LANG = (
        dto: LangParams,
        callback: (data: LangSettingRespond) => any,
    ) => {
        socket.emit(
            `${rootPath}.updateLanguage`,
            dto,
            callback,
        );
    };

    // 查询交易记录
    const EMIT_ACCOUNT_HISTORY = (
        data: any,
        callback: (data: LangSettingRespond) => any,
    ) => {
        socket.emit(
            `${rootPath}.getAccountHistory`,
            data,
            callback,
        );
    };

    return {
        EMIT_PROFILE_TOKEN,
        EMIT_PROFILE_GETCURRENCIES,
        EMIT_PROFILE_USER_STATISTIC,
        EMIT_USER_LANG,
        EMIT_ACCOUNT_HISTORY
    };
};


